import { takeEvery, fork, all, takeLatest } from 'redux-saga/effects';
import {
    GET_DROPDOWN,
    GET_SHIP_TO_ADDRESS,
    GET_DERIVED_TERRITORIES,
    GET_PRICES_FOR_ITEMS,
    GET_CONSIGNMENT_DETAILS,
    GET_USAGE_DETAILS,
    GET_INVENTORY_DATA,
    USAGE_ATTACHMENT_UPLOAD,
    DELETE_ATTACHMENT_REQUEST,
    GET_IMAGE_PO_PREVIEW,
    VALIDATE_PRODUCT_DETAILS,
    UPDATE_CONSIGNMENT_DETAILS,
    SAVE_CONSIGNMENT_DETAILS,
    GET_TRANSFER_RECIPIENT_METHODS,
    VALIDATE_REPLEN,
    VALIDATE_ACCOUNT
} from '../actions';
import getConsignmentDropDownSaga from './getDropDownSaga';
import getShipToAddressSaga from './shipToAddressSaga';
import getDerivedTerritories from './derivedTerritorySaga';
import updateConsignment from './updateConsignmentSaga';
import {
    getConsignmentDetails,
    usageAttachmentUploadSaga,
    deleteAttachmentSaga,
    getImagePoPreviewSaga,
    validateProductDetailsInBillingSaga,
    validateRelenSaga,
} from './getConsignmentDetailsSaga';
import validateAccountSaga from './validateAccountSaga';
import getUsageDetails from './usageDetails';
import getInventoryDetails from './getInventoryDetailsSaga';
import saveConsignment from './createConsignmentSaga';
import getPricesForConsignmentItemsSaga from './getPricesForItemsSaga';
import getTransferRecipient from './transferRecipientSaga';

function* watchConsignmentGetDropDownSaga() {
    yield takeEvery(GET_DROPDOWN, getConsignmentDropDownSaga);
}

function* watchGetShipToAddressSaga() {
    yield takeEvery(GET_SHIP_TO_ADDRESS, getShipToAddressSaga);
}

function* watchGetDerivedTerritoriesSaga() {
    yield takeLatest(GET_DERIVED_TERRITORIES, getDerivedTerritories);
}

function* watchGetConsignmentDetailsSaga() {
    yield takeLatest(GET_CONSIGNMENT_DETAILS, getConsignmentDetails);
}

function* watchGetUsageDetailsSaga() {
    yield takeLatest(GET_USAGE_DETAILS, getUsageDetails);
}

function* watchGetInventoryDetailsSaga() {
    yield takeLatest(GET_INVENTORY_DATA, getInventoryDetails);
}

function* watchUsageUploadAttcahmentSaga() {
    yield takeLatest(USAGE_ATTACHMENT_UPLOAD, usageAttachmentUploadSaga);
}
function* watchUsageDeleteAttcahmentSaga() {
    yield takeLatest(DELETE_ATTACHMENT_REQUEST, deleteAttachmentSaga);
}
function* watchGetImagePOPreviewSaga() {
    yield takeLatest(GET_IMAGE_PO_PREVIEW, getImagePoPreviewSaga);
}

function* watchValidateProductDetailsInBillingSaga() {
    yield takeLatest(
        VALIDATE_PRODUCT_DETAILS,
        validateProductDetailsInBillingSaga
    );
}
function* watchValidateRelenSaga() {
    yield takeLatest(
        VALIDATE_REPLEN,
        validateRelenSaga
    );
}

function* watchValidateAccountSaga() {
    yield takeLatest(VALIDATE_ACCOUNT, validateAccountSaga);
}

function* watchUpdateConsignmentSaga() {
    yield takeLatest(UPDATE_CONSIGNMENT_DETAILS, updateConsignment);
}
function* watchSaveConsignmentSaga() {
    yield takeLatest(SAVE_CONSIGNMENT_DETAILS, saveConsignment);
}
function* watchGetPricesForConsignmentItemsSaga() {
    yield takeLatest(GET_PRICES_FOR_ITEMS, getPricesForConsignmentItemsSaga);
}

function* watchConsignmentBillingTransferRecipientSaga() {
    yield takeEvery(GET_TRANSFER_RECIPIENT_METHODS, getTransferRecipient);
}

export default function* consignmentDetailsRootSaga() {
    yield all([
        fork(watchGetConsignmentDetailsSaga),
        fork(watchGetUsageDetailsSaga),
        fork(watchGetInventoryDetailsSaga),
        fork(watchGetShipToAddressSaga),
        fork(watchUsageUploadAttcahmentSaga),
        fork(watchUsageDeleteAttcahmentSaga),
        fork(watchGetImagePOPreviewSaga),
        fork(watchValidateProductDetailsInBillingSaga),
        fork(watchGetDerivedTerritoriesSaga),
        fork(watchUpdateConsignmentSaga),
        fork(watchSaveConsignmentSaga),
        fork(watchConsignmentGetDropDownSaga),
        fork(watchGetPricesForConsignmentItemsSaga),
        fork(watchConsignmentBillingTransferRecipientSaga),
        fork(watchValidateRelenSaga),
        fork(watchValidateAccountSaga),

    ]);
}